import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Title shown in the global page header, set per page via the usePageHeader hook. Only the title
 * lives in Redux; the header's action buttons are React nodes, which don't belong in a serializable
 * store, so those travel through PageHeaderActionsProvider context instead.
 */
export interface PageHeaderState {
	title: string;
}

const initialState: PageHeaderState = {
	title: ""
};

const pageHeaderSlice = createSlice({
	name: "pageHeader",
	initialState,
	reducers: {
		setPageHeader(state, action: PayloadAction<PageHeaderState>) {
			state.title = action.payload.title;
		},
		clearPageHeader(state) {
			state.title = "";
		}
	}
});

export const { setPageHeader, clearPageHeader } = pageHeaderSlice.actions;
export const { reducer } = pageHeaderSlice;
